import {
  Flex,
  Text,
  Anchor,
  Stack,
  Paper,
  Grid,
  Image,
  Box,
} from '@mantine/core';
import { Outlet } from 'react-router-dom';
import backgroundImage from '../../assets/images/login_bg.png';

import classes from './Layout.module.scss';

export default function Layout() {
  return (
    <Grid gutter={0} style={{ overflow: 'hidden' }}>
      <Grid.Col span={{ base: 12, lg: 8 }}>
        <Flex
          bg="hsl(210 25% 97%)"
          className={classes.leftBorder}
          direction="column"
          style={{ minHeight: '100vh' }}
        >
          <Flex
            direction="column"
            align="center"
            justify="center"
            style={{ flex: 1 }}
          >
            <Paper radius="md" shadow="md">
              <Stack w="100%" align="center">
                <Outlet />
              </Stack>
            </Paper>
          </Flex>

          <Text size="xs" ta="left" w="100%" px="md" pb="md">
            © {new Date().getFullYear()} Kakitangan.com All rights reserved.
            This page is protected by reCAPTCHA. Google&apos;s{' '}
            <Anchor href="https://policies.google.com/privacy">
              Privacy Policy
            </Anchor>{' '}
            and{' '}
            <Anchor href="https://policies.google.com/terms">
              Terms of Service
            </Anchor>{' '}
            apply.
          </Text>
        </Flex>
      </Grid.Col>

      <Grid.Col
        span={{ md: 4 }}
        visibleFrom="lg"
        className={classes.loginBackground}
        style={{
          height: '100vh',
          padding: 0,
        }}
      />
    </Grid>
  );
}
